import styled from "styled-components"

export default function ProductOrderWrapper({ children }) {
  return <Section>{children}</Section>
}

const Section = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
`
